Ext.define('SA.view.ImportCountrySection', {
    alias: 'widget.import-country-section',
    extend: 'SA.view.SimpleContainer',

    items: [
        {
            xtype: 'component',
            cls: 'sa-import-country-section-label',
            html: 'What country is this dataset for?'
        }, {
            xtype: 'combo-button',
            itemId: 'dropDown',
            textField: 'label',
            valueField: 'id',

            buildItems() {
                var countryToItem = country => ({id: country.getCode(), label: country.getName()});

                return SA.Institution.getCountries().map(countryToItem);
            }
        }
    ],

    initComponent() {
        this.callParent();

        this.dropDown = this.down('#dropDown');

        this.dropDown.setValue(SA.AppController.getCurrentCountryCode());
    },

    getValue() {
        return this.dropDown.getValue();
    },

    initEvents() {
        this.callParent();

        this.dropDown.on('change', this.onDropDownChange, this);
    },

    onDropDownChange() {
        this.fireEvent('change');
    }
});
